import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useProfileScore = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['profileScore'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/profile/score` });
      return result;
    },
    staleTime: 5 * 60 * 1000, 
    cacheTime: 10 * 60 * 1000
  });
};
